import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getAllMedia = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = "";
  if (params.search)
    url = `/admin/media?page=${page}&size=${size}&search=${params.search}`;
  else url = `/admin/media?page=${page}&size=${size}`;

  const response = await axios.post<any>(
    url,
    {}, // empty body
    {
      headers: getHeader(), // ✅ properly placed
    }
  );

  return response.data;
};


export const addNewMedia = async (formData: FormData): Promise<any> => {
  let url = `/admin/media/upload`;
  const response = await axios.post<any>(url, formData, {
 headers: getHeader(),
  });
  return response.data;
};

export const deleteMedia = async (id: number): Promise<any> => {
  let url = `/admin/media/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
